import { type CreditCardDialogContext } from '@cart-services/hooks/credit-card-dialog-types'
import { DialogCreditCardConfirm } from '@cart-ui/DialogCreditCardConfirm/DialogCreditCardConfirm'
import { type CountryCode } from '@constants'
import { type CheckoutPayCreditCardModule } from '@payments'
import { useFpB2bCreditCardDialogFlow } from '../../fp-b2b-shared/hooks/use-fp-b2b-credit-card-dialog-flow'

export interface MerchantCreditCardDialogProps {
  context: CreditCardDialogContext
  paymentModule: CheckoutPayCreditCardModule
  countryCode: CountryCode
  onClose: () => void
  onError: (error: unknown) => void
}

export const MerchantCreditCardDialog = ({
  context,
  paymentModule,
  countryCode,
  onClose,
  onError,
}: MerchantCreditCardDialogProps) => {
  const { mountCreditCardFields, submitAndExecute, cancelInFlight, revealCardValidationErrors, isCreditCardValid } = useFpB2bCreditCardDialogFlow({
    paymentModule,
    countryCode,
  })
  return (
    <DialogCreditCardConfirm
      context={context}
      onClose={onClose}
      onError={onError}
      isCreditCardValid={isCreditCardValid}
      revealCardValidationErrors={revealCardValidationErrors}
      mountCreditCardFields={mountCreditCardFields}
      submitAndExecute={submitAndExecute}
      cancelInFlight={cancelInFlight}
    />
  )
}
